import { Component } from '@angular/core';
@Component({
  selector: 'cm-terms-and-conditions',
  templateUrl: './term-and-conditions.component.html',
  styleUrls: ['./term-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent {
  constructor() {}
}
